
export default {
	UPDATE_SELECTED_FACTORS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.selectedFactors = [...payload];
	},
	UPDATE_SELECTED_FACTOR(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.weighing.selectedFactor = payload;
	},
	UPDATE_FACTORS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.factorList = payload;
	},
	UPDATE_DEGREES(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degreesList = payload;
	},
	UPDATE_COMBINATIONS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.weighing.combinations = payload;
	},
	UPDATE_SELECTED_FACTOR_DEGREE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degree.selectedFactor = payload;
	},
	UPDATE_FACTOR_DEGREES(state, factorDegrees) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degree.factorDegrees = {
			...state.supplies.valuationModel.degree.factorDegrees,
			...factorDegrees,
		};
	},
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/valuation-model/mutations.js